<template>
  <div class="list-table-file-size">
    {{ util.numberToSize(scope.row.size) }}
  </div>
</template>

<script>
export default {
  name: 'ListTableFileSize',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
